module.exports = __webpack_public_path__ + "static/img/Proficiency_Exam.987c7015.png";